var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isConnectedClient)?_c('loader'):(_vm.errorConnected)?_c('div',{staticClass:"error-connected"},[_vm._v(_vm._s(_vm.errorConnected))]):[_c('Header'),_c('Layout')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }